// WebSocket URL for backend push events. Falls back to same-origin /api/ws (proxied to the
// backend by setupProxy.js) so the site works even when REACT_APP_WS_URL isn't loaded.
export function getWsUrl() {
  if (process.env.REACT_APP_WS_URL) return process.env.REACT_APP_WS_URL;
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${window.location.host}/api/ws`;
}
